import React from "react"
import { Uploader } from "../../components/Uploader"
import { useStore } from "../../containers"
import { UploadChangeParam } from "antd/lib/upload"

type Props = {
  label: string
  onChange: (fn: Function) => void
  onComplete: (e: UploadChangeParam) => void
}

export function ZoopUploader({ label, onChange, onComplete }: Props) {
  const { uploadUrl, zoopAuth } = useStore()

  return (
    <Uploader
      accept=".jpg,.png,.gif,.pdf"
      label={label}
      auth={zoopAuth}
      action={uploadUrl}
      data={{ category: "identificacao" }}
      onComplete={onComplete}
      onSetUploadResolver={fn => {
        onChange(fn)
      }}
    />
  )
}
